import { APIcallFunction, headerForPrivateAPI } from "../_helpers";
import { alertActions } from "./alert.actions";
import { ContactUsListConstants } from "../_constants/ContactUs.constants";
export const contactUsListActions = {
  getSupportListPromise,
  getSupportList,
  replyMsgTicketAdmin,
  getSupportListMessage,
  getSupportListMessageByPromise,
  replyMsgTicketAdminByPromise,
  ticketPriorityUpdate,
  ticketStatusUpdate
};

function replyMsgTicketAdminByPromise(data, resData) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/support/replyMessageOnTicket",
  };
  return APIcallFunction(credentials)
}


function getSupportListPromise(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/support/getTicketList'
  }
  return APIcallFunction(credentials)
};


function ticketPriorityUpdate(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/support/ticketPriorityUpdate'
  }
  return APIcallFunction(credentials)
};



function ticketStatusUpdate(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/support/ticketStatusUpdate'
  }
  return APIcallFunction(credentials)
};



function getSupportList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/support/getTicketList'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) { return { type: ContactUsListConstants.GET_SUPPORT_LIST_REQUEST, user } }
  function success(user) { return { type: ContactUsListConstants.GET_SUPPORT_LIST_SUCCESS, user } }
  function failure(error) { return { type: ContactUsListConstants.GET_SUPPORT_LIST_FAILURE, error } }
}

//reply Message Ticket Admin
function replyMsgTicketAdmin(data, resData) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/support/replyMessageOnTicket",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        // dispatch(getSupportListMessage(resData));
        dispatch(success(user));
        // dispatch(alertActions.success("Success."));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return { type: ContactUsListConstants.GET_REPLYTICKETADMIN_REQUEST, user };
  }
  function success(user) {
    return { type: ContactUsListConstants.GET_REPLYTICKETADMIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: ContactUsListConstants.GET_REPLYTICKETADMIN_FAILURE, error };
  }
}

function getSupportListMessageByPromise(data) {
  return APIcallFunction({
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/support/getMessageOnTicketList'
  });
}

function getSupportListMessage(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/support/getMessageOnTicketList'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) { return { type: ContactUsListConstants.GET_MESSAGEONSUPPORT_LIST_REQUEST, user } }
  function success(user) { return { type: ContactUsListConstants.GET_MESSAGEONSUPPORT_LIST_SUCCESS, user } }
  function failure(error) { return { type: ContactUsListConstants.GET_MESSAGEONSUPPORT_LIST_FAILURE, error } }
}
